import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  usePlanningDraftSprintDelete,
  IPlanningDraftSprint,
} from 'features/planning';

import { ButtonIcon } from 'shared/components/Button';

type TPlanningDraftSprintDeleteButton = {
  sprint: IPlanningDraftSprint;
};

export const PlanningDraftSprintDeleteButton = ({
  sprint,
}: TPlanningDraftSprintDeleteButton) => {
  const onDeleteButtonClick = usePlanningDraftSprintDelete({ sprint });

  return (
    <ButtonIcon
      aria-label="delete"
      data-testid="delete-btn"
      variant="ghost"
      onClick={onDeleteButtonClick}
    >
      <Icon
        name={iconNames.binFilled}
        width="16px"
        height="16px"
        fill="var(--fgPrimary)"
      />
    </ButtonIcon>
  );
};
